import React from 'react';

export default () => {
  return (
    <div>
      <h1 className="display-4">
        <span className="text-danger">404</span> Page Not Found
      </h1>
      <p className="lead">Ooops, that page does not exist</p>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/pages/NotFound.js